<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M21.31 13.53a2.13 2.13 0 0 0-.63-3.52 4.72 4.72 0 0 0-1.82-.33H15.19l.3-.7c.52-1.24.97-2.5 1.09-3.85.05-.67.02-1.33-.28-1.93-.35-.7-.9-1.15-1.7-1.2a1.9 1.9 0 0 0-1.79.9c-.28.42-.44.9-.52 1.39A7.57 7.57 0 0 1 10.9 7.5c-.61.84-1.33 1.58-2.03 2.34-.35-.38-.9-.62-1.52-.62h-3.4c-1.1 0-1.96.74-1.96 1.69v9.39c0 .95.87 1.69 1.96 1.69h3.4c.8 0 1.47-.4 1.77-.97.87.45 1.81.62 2.8.62h5.61c.82 0 1.4-.4 1.76-1.12.17-.36.24-.74.25-1.14 0-.14.05-.21.17-.29a1.86 1.86 0 0 0 .97-2.05l-.14-.52c.94-.57 1.32-1.56.61-2.9l.15-.1ZM7.66 20.24s-.13.09-.3.09h-3.4a.58.58 0 0 1-.3-.08v-9.28s.14-.07.3-.07h3.4c.14 0 .24.04.3.09v9.26Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
